export interface CreatePatientResponse {
  firstname: string;
  lastname: string;
  tutor_name?: string | null;
  email: string | undefined;
  id_number: number | null;
  phone_number: string | undefined;
  address?: string | undefined;
  health_insurance_id?: number | null;
  prepaid_id?: number | null;
  id_card?: number | null;
  pathologies?: number[];
  gender?: string;
  birthdate: string | null;
  medic_id: number | null;
}
